module.exports = __webpack_public_path__ + "img/Step2-m.de5c4a2.svg";